import initialState from './initialState';
import {
  FORMULA_EDITOR_GET_DIMENSIONS_LIST_INIT,
  FORMULA_EDITOR_GET_DIMENSIONS_LIST_SUCCESS,
  FORMULA_EDITOR_GET_DIMENSIONS_LIST_FAILURE,
  FORMULA_EDITOR_GET_METRICS_LIST_INIT,
  FORMULA_EDITOR_GET_METRICS_LIST_SUCCESS,
  FORMULA_EDITOR_GET_METRICS_LIST_FAILURE,
  FORMULA_EDITOR_GET_POLYNOMIALS_LIST_INIT,
  FORMULA_EDITOR_GET_POLYNOMIALS_LIST_SUCCESS,
  FORMULA_EDITOR_GET_POLYNOMIALS_LIST_FAILURE,
  FORMULA_EDITOR_GET_DIMENSION_INSTANCES_SELECT_LIST_INIT,
  FORMULA_EDITOR_GET_DIMENSION_INSTANCES_SELECT_LIST_SUCCESS,
  FORMULA_EDITOR_GET_DIMENSION_INSTANCES_SELECT_LIST_FAILURE,
  FORMULA_EDITOR_SET_FORMULA_TO_EDIT_OBJECT,
  FORMULA_EDITOR_EDIT_FORMULA_TO_EDIT_OBJECT,
  FORMULA_EDITOR_EDIT_FORMULA_TO_EDIT_OBJECT_ENTITY_DATA,
  FORMULA_EDITOR_CHANGE_COLLAPSE_FORMULA_ENTITY,
  FORMULA_EDITOR_CHANGE_COLLAPSE_ALL_FORMULA_ENTITY,
  FORMULA_EDITOR_DELETE_FORMULA_ENTITY,
  FORMULA_EDITOR_FORMULA_CREATE_MARK,
  FORMULA_EDITOR_FORMULA_CUT,
  FORMULA_EDITOR_FORMULA_PASTE,
  FORMULA_EDITOR_FORMULA_VALIDATION_INIT,
  FORMULA_EDITOR_FORMULA_VALIDATION_SUCCESS,
  FORMULA_EDITOR_FORMULA_VALIDATION_FAILURE,
  FORMULA_EDITOR_FORMULA_GRAMMAR_VALIDATION_INIT,
  FORMULA_EDITOR_FORMULA_GRAMMAR_VALIDATION_SUCCESS,
  FORMULA_EDITOR_FORMULA_GRAMMAR_VALIDATION_FAILURE,
  FORMULA_EDITOR_RESET
} from '../../actions/formulaEditor/types';
import ReducersTooling from '../../../tooling/reducersTooling';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import FormulaUtilsTooling from '../../../tooling/formulaUtilsTooling';

export default function formulaEditor(state = initialState, action) {
  switch (action.type) {      
    case FORMULA_EDITOR_GET_DIMENSIONS_LIST_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "dimensionsList");
    case FORMULA_EDITOR_GET_DIMENSIONS_LIST_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "dimensionsList");
    case FORMULA_EDITOR_GET_DIMENSIONS_LIST_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "dimensionsList");
    case FORMULA_EDITOR_GET_METRICS_LIST_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "metricsList");
    case FORMULA_EDITOR_GET_METRICS_LIST_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "metricsList");
    case FORMULA_EDITOR_GET_METRICS_LIST_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "metricsList");
    case FORMULA_EDITOR_GET_POLYNOMIALS_LIST_INIT:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateInitList(initialState, state, action, "polynomialsList");
    case FORMULA_EDITOR_GET_POLYNOMIALS_LIST_SUCCESS:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateSuccessList(initialState, state, action, "polynomialsList");
    case FORMULA_EDITOR_GET_POLYNOMIALS_LIST_FAILURE:
      return ReducersTooling.entityTableReducers.getFetchTypeNewStateFailureList(initialState, state, action, "polynomialsList");
    case FORMULA_EDITOR_GET_DIMENSION_INSTANCES_SELECT_LIST_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "dimensionInstancesSelectList");
    case FORMULA_EDITOR_GET_DIMENSION_INSTANCES_SELECT_LIST_SUCCESS:
      return ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "dimensionInstancesSelectList");
    case FORMULA_EDITOR_GET_DIMENSION_INSTANCES_SELECT_LIST_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "dimensionInstancesSelectList");
    case FORMULA_EDITOR_SET_FORMULA_TO_EDIT_OBJECT:
      return {
        ...state,
        formulaToEditObject: action.formulaObject,
        formulaValidation: initialState.formulaValidation
      }
    case FORMULA_EDITOR_EDIT_FORMULA_TO_EDIT_OBJECT:
      return {
        ...state,
        formulaToEditObject: FormulaUtilsTooling.editFormulaObject(state.formulaToEditObject, action.parentId, action.index, action.position, action.valueToAdd, action.contextInfo)
      } 
    case FORMULA_EDITOR_EDIT_FORMULA_TO_EDIT_OBJECT_ENTITY_DATA:
      return {
        ...state,
        formulaToEditObject: FormulaUtilsTooling.editFormulaObjectEntityData(state.formulaToEditObject, action.entityId, action.path, action.data)
      }
    case FORMULA_EDITOR_CHANGE_COLLAPSE_FORMULA_ENTITY:
      return {
        ...state,
        formulaToEditObject: FormulaUtilsTooling.changeCollapseEntity(state.formulaToEditObject, action.entityId, action.forceOpen)
      }
    case FORMULA_EDITOR_CHANGE_COLLAPSE_ALL_FORMULA_ENTITY:
      return {
        ...state,
        formulaToEditObject: FormulaUtilsTooling.changeCollapseAllEntity(state.formulaToEditObject, action.collapse)
      }
    case FORMULA_EDITOR_DELETE_FORMULA_ENTITY:
      return {
        ...state,
        formulaToEditObject: FormulaUtilsTooling.deleteEntity(state.formulaToEditObject, action.entityId)
      }
    case FORMULA_EDITOR_FORMULA_CREATE_MARK:
      return {
        ...state,
        formulaToEditObject: FormulaUtilsTooling.createMark(state.formulaToEditObject, action.segmentObject)
      }
    case FORMULA_EDITOR_FORMULA_CUT:
      return {
        ...state,
        formulaToEditObject: FormulaUtilsTooling.deleteFormula(state.formulaToEditObject, action.segmentObject)
      }
    case FORMULA_EDITOR_FORMULA_PASTE:
      return {
        ...state,
        formulaToEditObject: FormulaUtilsTooling.pasteFormula(state.formulaToEditObject, action.positionObject, action.formulaToPaste)
      }
    case FORMULA_EDITOR_FORMULA_VALIDATION_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "formulaValidation");
    case FORMULA_EDITOR_FORMULA_VALIDATION_SUCCESS:
      let newState = ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "formulaValidation");
      if(action.payload.status == 422 && action.payload.data && action.payload.data.formulaArray) {
        newState.formulaToEditObject = action.payload.data;
      }
      return newState
    case FORMULA_EDITOR_FORMULA_VALIDATION_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "formulaValidation");
    case FORMULA_EDITOR_FORMULA_GRAMMAR_VALIDATION_INIT:
      return ReducersTooling.generalReducers.getFetchTypeNewStateInit(initialState, state, action, "formulaGrammarValidation");
    case FORMULA_EDITOR_FORMULA_GRAMMAR_VALIDATION_SUCCESS:
      let newState2 = ReducersTooling.generalReducers.getFetchTypeNewStateSuccess(initialState, state, action, "formulaGrammarValidation");
      if(action.payload.status == 200 && action.payload.data && action.payload.data.formulaArray) {
        newState2.formulaToEditObject = action.payload.data;
      }
      return newState2
    case FORMULA_EDITOR_FORMULA_GRAMMAR_VALIDATION_FAILURE:
      return ReducersTooling.generalReducers.getFetchTypeNewStateFailure(initialState, state, action, "formulaGrammarValidation");
    case FORMULA_EDITOR_RESET:
      return initialState;
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./source/client/reducers/formulaEditor/index.js